import { Alert as ChakraAlert } from '@chakra-ui/react';
import * as React from 'react';

import CloseButton from 'ui/CloseButton';

type Status = 'info' | 'warning' | 'error';

const statusProps: Record<Status, Partial<ChakraAlert.RootProps>> = {
  info: { background: 'blue.50', color: 'blue.700' },
  warning: { background: 'yellow.100', color: 'yellow.700' },
  error: { background: 'red.100', color: 'red.600' },
};

export type AlertProps = Omit<
  ChakraAlert.RootProps,
  'title' | 'variant' | 'status'
> & {
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  title?: React.ReactNode;
  icon?: React.ReactElement;
  status: Status;
  closable?: boolean;
  onClose?: () => void;
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  (
    {
      title,
      status,
      children,
      icon,
      closable,
      onClose,
      startElement,
      endElement,
      ...rest
    },
    ref
  ) => (
    <ChakraAlert.Root
      ref={ref}
      mb={3}
      status={status}
      {...statusProps[status]}
      {...rest}
    >
      {startElement || <ChakraAlert.Indicator>{icon}</ChakraAlert.Indicator>}
      {children ? (
        <ChakraAlert.Content>
          <ChakraAlert.Title fontWeight="semibold">{title}</ChakraAlert.Title>
          <ChakraAlert.Description>{children}</ChakraAlert.Description>
        </ChakraAlert.Content>
      ) : (
        <ChakraAlert.Title flex="1" fontWeight="semibold">
          {title}
        </ChakraAlert.Title>
      )}
      {endElement}
      {closable && (
        <CloseButton
          size="sm"
          pos="relative"
          top="-2"
          insetEnd="-2"
          alignSelf="flex-start"
          onClick={onClose}
        />
      )}
    </ChakraAlert.Root>
  )
);

export default Alert;
